<div>
  <div class="matter-sb-header" style="border-top: none" (click)="sidebarExpand.administration = !sidebarExpand.administration">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.administration ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Administer this Contact
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.administration">
    <hr class="my-1" />
    <div class="row">
      <div class="col">
        <h6 class="font-weight-bold">
          Clone
          <span *ngIf="clonedContactId">
            &nbsp;
            <a [routerLink]="'/contacts/' + clonedContactId"> Cloned Contact Link </a>
          </span>
        </h6>
        <div class="d-flex">
          <div class="pr-2">
            <button [disabled]="cloning" type="button" class="btn btn-primary" (click)="clone()">
              <i class="fas fa-clone"></i>
              &nbsp; Clone
              <span *ngIf="cloning">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
          <div class="flex-grow-1">
            <div class="custom-control custom-checkbox" (click)="cloneParams.cloneOptionsCheck['Addresses'] = !cloneParams.cloneOptionsCheck['Addresses']">
              <input type="checkbox" class="custom-control-input" [checked]="cloneParams.cloneOptionsCheck['Addresses']" />
              <label class="custom-control-label">Addresses</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="cloneParams.cloneOptionsCheck['Display Name'] = !cloneParams.cloneOptionsCheck['Display Name']">
              <input type="checkbox" class="custom-control-input" [checked]="cloneParams.cloneOptionsCheck['Display Name']" />
              <label class="custom-control-label">Display Name</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="cloneParams.cloneOptionsCheck['Email Addresses'] = !cloneParams.cloneOptionsCheck['Email Addresses']">
              <input type="checkbox" class="custom-control-input" [checked]="cloneParams.cloneOptionsCheck['Email Addresses']" />
              <label class="custom-control-label">Email Addresses</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="cloneParams.cloneOptionsCheck['Name'] = !cloneParams.cloneOptionsCheck['Name']">
              <input type="checkbox" class="custom-control-input" [checked]="cloneParams.cloneOptionsCheck['Name']" />
              <label class="custom-control-label">Name</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="cloneParams.cloneOptionsCheck['Phone Numbers'] = !cloneParams.cloneOptionsCheck['Phone Numbers']">
              <input type="checkbox" class="custom-control-input" [checked]="cloneParams.cloneOptionsCheck['Phone Numbers']" />
              <label class="custom-control-label">Phone Numbers</label>
            </div>
            <div *ngIf="sidebarContactInfo.type == 'Person'" class="custom-control custom-checkbox" (click)="cloneParams.cloneOptionsCheck['Company Instead of Person'] = !cloneParams.cloneOptionsCheck['Company Instead of Person']">
              <input type="checkbox" class="custom-control-input" [checked]="cloneParams.cloneOptionsCheck['Company Instead of Person']" />
              <label class="custom-control-label">Company instead of person</label>
            </div>
            <div *ngIf="sidebarContactInfo.type == 'Company'" class="custom-control custom-checkbox" (click)="cloneParams.cloneOptionsCheck['Person Instead of Company'] = !cloneParams.cloneOptionsCheck['Person Instead of Company']">
              <input type="checkbox" class="custom-control-input" [checked]="cloneParams.cloneOptionsCheck['Person Instead of Company']" />
              <label class="custom-control-label">Person instead of company</label>
            </div>
          </div>
        </div>
        <app-intranet-search (intranet_id)="cloneParams.intranet = { id: $event }" (clearIntranet)="cloneParams.intranet = undefined" [placeholder]="'Search for Intranet as copy destination'"></app-intranet-search>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col">
        <h6 class="font-weight-bold">Delete</h6>
        <button type="button" (click)="deleteContact()" [disabled]="deleting" class="btn btn-danger btn-block">
          <i class="fas fa-trash"></i>&nbsp;
          {{ deleting ? 'Deleting' : 'Delete this Contact' }}
          <span *ngIf="deleting">
            &nbsp;
            <i class="fas fa-fw fa-spinner fa-pulse"></i>
          </span>
        </button>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col">
        <h6 class="font-weight-bold">Merge</h6>
        <div class="d-flex pb-2">
          <div class="pr-2">
            <button [disabled]="merging" type="button" class="btn btn-warning" (click)="merge()">
              <i class="fas fa-layer-group"></i>
              &nbsp; Merge
              <span *ngIf="merging">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
          <div class="flex-grow-1">
            <app-contact-search #mergeContactSearch [params]="{ exclude_contact_id: contact_id }" (contact_id)="mergeParams.loser_id = $event" (clearContact)="mergeParams.loser_id = undefined"></app-contact-search>
          </div>
        </div>
        <span class="form-text text-muted" *ngIf="mergeParams && mergeParams.loser_id">The above selected contact will be merged here and deleted.</span>
      </div>
    </div>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.addresses = !sidebarExpand.addresses">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.addresses ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Addresses
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.addresses">
    <app-address-index [contactId]="contact_id"></app-address-index>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.aliases = !sidebarExpand.aliases">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.aliases ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Aliases
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.aliases">
    <app-aka-index [contactId]="contact_id"></app-aka-index>
    <br /><br />
  </div>
</div>
<div *ngIf="billings">
  <div class="matter-sb-header" (click)="sidebarExpand.billings = !sidebarExpand.billings">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)">
        <i [class]="'fa fa-' + (sidebarExpand.billings ? 'minus' : 'plus') + '-circle'"></i> </a
      >&nbsp;&nbsp;Billings &nbsp;
      <small>
        <app-badge badgeType="primary">
          {{ sidebarContactInfo.billing_count }}
        </app-badge>
      </small>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.billings">
    <div class="text-center pt-2 pagination-small-margin pagination-center">
      <div class="float-right">
        <button type="button" title="Refresh" [disabled]="loadingBillings" (click)="loadBillings()" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingBillings }"></i>
        </button>
      </div>
      <div class="float-left" *ngIf="sidebarContactInfo.billing_count > (sidebarContactInfo.per_page || 20)">
        <pagination
          [(ngModel)]="billingParams.page"
          [boundaryLinks]="true"
          [totalItems]="sidebarContactInfo.billing_count"
          (pageChanged)="loadBillings($event.page)"
          class="pagination-sm"
          [itemsPerPage]="billingParams.per_page || 20"
          [maxSize]="3"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pt-2"></div>
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>#</th>
          <th class="text-center">Week Ending</th>
          <th class="text-right">Hours</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let billing of billings">
          <td>{{ billing.week }}</td>
          <td class="text-center">{{ billing.week_ending }}</td>
          <td class="text-right">{{ billing.quantity || 0 | number: '1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="pt-2"></div>
    <div class="text-center pagination-small-margin pagination-center" *ngIf="sidebarContactInfo.billing_count > (sidebarContactInfo.per_page || 20)">
      <pagination
        [(ngModel)]="billingParams.page"
        [boundaryLinks]="true"
        [totalItems]="sidebarContactInfo.billing_count"
        (pageChanged)="loadBillings($event.page)"
        class="pagination-sm"
        [itemsPerPage]="billingParams.per_page || 20"
        [maxSize]="3"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      ></pagination>
    </div>
    <br /><br />
  </div>
</div>
<div *ngIf="documents">
  <div class="matter-sb-header" (click)="sidebarExpand.documents = !sidebarExpand.documents">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.documents ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Documents &nbsp;
      <small>
        <app-badge badgeType="primary">
          {{ sidebarContactInfo.document_count }}
        </app-badge>
      </small>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.documents">
    <div class="text-center pt-2 pagination-small-margin pagination-center">
      <div class="float-right">
        <button type="button" title="Refresh" [disabled]="loadingDocuments" (click)="loadDocuments()" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingDocuments }"></i>
        </button>
      </div>
      <div class="float-left" *ngIf="sidebarContactInfo.document_count > (sidebarContactInfo.per_page || 20)">
        <pagination
          [(ngModel)]="documentParams.page"
          [boundaryLinks]="true"
          [totalItems]="sidebarContactInfo.document_count"
          (pageChanged)="loadDocuments($event.page)"
          class="pagination-sm"
          [itemsPerPage]="documentParams.per_page || 20"
          [maxSize]="3"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pt-2"></div>
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Matter</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let document of documents">
          <td>
            <button type="button" class="btn btn-link btn-sm p-0" (click)="downloadDocument($event, document.id)" style="border: none; background: none; color: #007bff; cursor: pointer; text-decoration: none;">
              {{ document.name }}
            </button>
          </td>
          <td>{{ document.document_type_name }}</td>
          <td>
            <a [routerLink]="'/matters/' + document.matter_id">
              {{ document.matter_number }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pt-2"></div>
    <div class="text-center pagination-small-margin pagination-center" *ngIf="sidebarContactInfo.document_count > (sidebarContactInfo.per_page || 20)">
      <pagination
        [(ngModel)]="documentParams.page"
        [boundaryLinks]="true"
        [totalItems]="sidebarContactInfo.document_count"
        (pageChanged)="loadDocuments($event.page)"
        class="pagination-sm"
        [itemsPerPage]="documentParams.per_page || 20"
        [maxSize]="3"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      ></pagination>
    </div>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.edit = !sidebarExpand.edit">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.edit ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Edit
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.edit">
    <app-contact-form [contactId]="contact_id" (saveSuccessEvent)="contactFormSaveEventHander($event)"></app-contact-form>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.email_addresses = !sidebarExpand.email_addresses">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.email_addresses ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Email Addresses
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.email_addresses">
    <app-email-address-index [contactId]="contact_id" [isUser]="isUser"></app-email-address-index>
    <br /><br />
  </div>
</div>
<div *ngIf="employees">
  <div class="matter-sb-header" (click)="sidebarExpand.employees = !sidebarExpand.employees">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.employees ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Employees &nbsp;
      <small>
        <app-badge badgeType="primary">
          {{ sidebarContactInfo.employee_count }}
        </app-badge>
      </small>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.employees">
    <div class="text-center pt-2 pagination-small-margin pagination-center">
      <div class="float-right">
        <button type="button" title="Refresh" [disabled]="loadingEmployees" (click)="loadEmployees()" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingEmployees }"></i>
        </button>
      </div>
      <div class="float-left" *ngIf="sidebarContactInfo.employee_count > (sidebarContactInfo.per_page || 20)">
        <pagination
          [(ngModel)]="employeeParams.page"
          [boundaryLinks]="true"
          [totalItems]="sidebarContactInfo.employee_count"
          (pageChanged)="loadEmployees($event.page)"
          class="pagination-sm"
          [itemsPerPage]="employeeParams.per_page || 20"
          [maxSize]="3"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pt-2"></div>
    <table class="table table-sm table-striped">
      <tbody>
        <tr *ngFor="let employee of employees">
          <td>
            <a [routerLink]="'/contacts/' + employee.id">
              {{ employee.name }}
              <span *ngIf="employee.title"> &nbsp;{{ employee.title }} </span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pt-2"></div>
    <div class="text-center pagination-small-margin pagination-center" *ngIf="sidebarContactInfo.employee_count > (sidebarContactInfo.per_page || 20)">
      <pagination
        [(ngModel)]="employeeParams.page"
        [boundaryLinks]="true"
        [totalItems]="sidebarContactInfo.employee_count"
        (pageChanged)="loadEmployees($event.page)"
        class="pagination-sm"
        [itemsPerPage]="employeeParams.per_page || 20"
        [maxSize]="3"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      ></pagination>
    </div>
    <br /><br />
  </div>
</div>
<div *ngIf="matters">
  <div class="matter-sb-header" (click)="sidebarExpand.matters = !sidebarExpand.matters">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.matters ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Matters &nbsp;
      <small>
        <app-badge badgeType="primary">
          {{ sidebarContactInfo.matter_count }}
        </app-badge>
      </small>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.matters">
    <div class="text-center pt-2 pagination-small-margin pagination-center">
      <div class="float-right">
        <button type="button" title="Refresh" [disabled]="loadingMatters" (click)="loadMatters()" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingMatters }"></i>
        </button>
      </div>
      <div class="float-left" *ngIf="sidebarContactInfo.matter_count > (sidebarContactInfo.per_page || 20)">
        <pagination
          [(ngModel)]="matterParams.page"
          [boundaryLinks]="true"
          [totalItems]="sidebarContactInfo.matter_count"
          (pageChanged)="loadMatters($event.page)"
          class="pagination-sm"
          [itemsPerPage]="matterParams.per_page || 20"
          [maxSize]="3"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pt-2"></div>
    <table class="table table-sm table-striped">
      <tbody>
        <tr *ngFor="let matter of matters">
          <td>
            <a [routerLink]="'/matters/' + matter.id">
              {{ matter.number }}
            </a>
            &nbsp;-&nbsp;{{ matter.name }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pt-2"></div>
    <div class="text-center pagination-small-margin pagination-center" *ngIf="sidebarContactInfo.matter_count > (sidebarContactInfo.per_page || 20)">
      <pagination
        [(ngModel)]="matterParams.page"
        [boundaryLinks]="true"
        [totalItems]="sidebarContactInfo.matter_count"
        (pageChanged)="loadMatters($event.page)"
        class="pagination-sm"
        [itemsPerPage]="matterParams.per_page || 20"
        [maxSize]="3"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      ></pagination>
    </div>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.newsletter_mailinglists = !sidebarExpand.newsletter_mailinglists">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.newsletter_mailinglists ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Newsletter Mailing Lists
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.newsletter_mailinglists">
    <app-contact-newsletter-mailinglists [contactId]="contact_id"></app-contact-newsletter-mailinglists>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.phone_numbers = !sidebarExpand.phone_numbers">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.phone_numbers ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Phone Numbers
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.phone_numbers">
    <app-phone-number-index [contactId]="contact_id"></app-phone-number-index>
  </div>
</div>
<div *ngIf="checks">
  <div class="matter-sb-header" (click)="sidebarExpand.recent_distributions_to = !sidebarExpand.recent_distributions_to">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.recent_distributions_to ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Recent Distributions To &nbsp;
      <small>
        <app-badge badgeType="primary">
          {{ sidebarContactInfo.disbursement_count }}
        </app-badge>
      </small>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.recent_distributions_to">
    <div class="text-center pt-2 pagination-small-margin pagination-center">
      <div class="float-right">
        <button type="button" title="Refresh" [disabled]="loadingDisbursements" (click)="loadDisbursements()" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingDisbursements }"></i>
        </button>
      </div>
      <div class="float-left" *ngIf="sidebarContactInfo.disbursement_count > (sidebarContactInfo.per_page || 20)">
        <pagination
          [(ngModel)]="disbursementParams.page"
          [boundaryLinks]="true"
          [totalItems]="sidebarContactInfo.disbursement_count"
          (pageChanged)="loadDisbursements($event.page)"
          class="pagination-sm"
          [itemsPerPage]="disbursementParams.per_page || 20"
          [maxSize]="3"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pt-2"></div>
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th>No.</th>
          <th>Description</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let check of checks">
          <td>{{ check.check_number }}</td>
          <td>{{ check.description }}</td>
          <td>{{ check.amount | currency: 'USD':'symbol':'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="pt-2"></div>
    <div class="text-center pagination-small-margin pagination-center" *ngIf="sidebarContactInfo.disbursement_count > (sidebarContactInfo.per_page || 20)">
      <pagination
        [(ngModel)]="disbursementParams.page"
        [boundaryLinks]="true"
        [totalItems]="sidebarContactInfo.disbursement_count"
        (pageChanged)="loadDisbursements($event.page)"
        class="pagination-sm"
        [itemsPerPage]="disbursementParams.per_page || 20"
        [maxSize]="3"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      ></pagination>
    </div>
    <br /><br />
  </div>
</div>
<div *ngIf="bills">
  <div class="matter-sb-header" (click)="sidebarExpand.receipts_earned = !sidebarExpand.receipts_earned">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.receipts_earned ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Receipts Earned &nbsp;
      <small>
        <app-badge badgeType="primary">
          {{ sidebarContactInfo.bill_count }}
        </app-badge>
      </small>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.receipts_earned">
    <div class="text-center pt-2 pagination-small-margin pagination-center">
      <div class="float-right">
        <button type="button" title="Refresh" [disabled]="loadingBills" (click)="loadBills()" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingBills }"></i>
        </button>
      </div>
      <div class="float-left" *ngIf="sidebarContactInfo.bill_count > (sidebarContactInfo.per_page || 20)">
        <pagination
          [(ngModel)]="billParams.page"
          [boundaryLinks]="true"
          [totalItems]="sidebarContactInfo.bill_count"
          (pageChanged)="loadBills($event.page)"
          class="pagination-sm"
          [itemsPerPage]="billParams.per_page || 20"
          [maxSize]="3"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pt-2"></div>
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>Week Ending</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bill of bills">
          <td>{{ bill.week }}</td>
          <td>{{ bill.week_ending }}</td>
          <td>{{ bill.amount | currency: 'USD':'symbol':'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="pt-2"></div>
    <div class="text-center pagination-small-margin pagination-center" *ngIf="sidebarContactInfo.bill_count > (sidebarContactInfo.per_page || 20)">
      <pagination
        [(ngModel)]="billParams.page"
        [boundaryLinks]="true"
        [totalItems]="sidebarContactInfo.bill_count"
        (pageChanged)="loadBills($event.page)"
        class="pagination-sm"
        [itemsPerPage]="billParams.per_page || 20"
        [maxSize]="3"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      ></pagination>
    </div>
    <br /><br />
  </div>
</div>
<div *ngIf="receipts">
  <div class="matter-sb-header" (click)="sidebarExpand.receipts_from = !sidebarExpand.receipts_from">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.receipts_from ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Recent Receipts From &nbsp;
      <small>
        <app-badge badgeType="primary">
          {{ sidebarContactInfo.receipt_count }}
        </app-badge>
      </small>
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.receipts_from">
    <div class="text-center pt-2 pagination-small-margin pagination-center">
      <div class="float-right">
        <button type="button" title="Refresh" [disabled]="loadingReceipts" (click)="loadReceipts()" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingReceipts }"></i>
        </button>
      </div>
      <div class="float-left" *ngIf="sidebarContactInfo.receipt_count > (sidebarContactInfo.per_page || 20)">
        <pagination
          [(ngModel)]="receiptParams.page"
          [boundaryLinks]="true"
          [totalItems]="sidebarContactInfo.receipt_count"
          (pageChanged)="loadReceipts($event.page)"
          class="pagination-sm"
          [itemsPerPage]="receiptParams.per_page || 20"
          [maxSize]="3"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pt-2"></div>
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th>Matter</th>
          <th>Description</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let receipt of receipts">
          <td>
            <a *ngIf="receipt.matter_id" [routerLink]="'/matters/' + receipt.matter_id">
              {{ receipt.matter_number }}
            </a>
          </td>
          <td>{{ receipt.description }}</td>
          <td>{{ receipt.amount | currency: 'USD':'symbol':'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="pt-2"></div>
    <div class="text-center pagination-small-margin pagination-center" *ngIf="sidebarContactInfo.receipt_count > (sidebarContactInfo.per_page || 20)">
      <pagination
        [(ngModel)]="receiptParams.page"
        [boundaryLinks]="true"
        [totalItems]="sidebarContactInfo.receipt_count"
        (pageChanged)="loadReceipts($event.page)"
        class="pagination-sm"
        [itemsPerPage]="receiptParams.per_page || 20"
        [maxSize]="3"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      ></pagination>
    </div>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.relationships = !sidebarExpand.relationships">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.relationships ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Relationships
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.relationships">
    <app-contact-relationships [contactId]="contact_id"></app-contact-relationships>
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.reminders = !sidebarExpand.reminders">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.reminders ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Reminders
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.reminders">
    <app-reminder-common [reminderable_fields]="reminderableFields" [reminderable_type]="'Contact'" [reminderable_id]="contact_id"></app-reminder-common>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.tags = !sidebarExpand.tags">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.tags ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Tags
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.tags">
    <app-contact-tags [contactId]="contact_id"></app-contact-tags>
  </div>
</div>
<div *ngIf="sidebarContactInfo && sidebarContactInfo.anniversary_date">
  <div class="matter-sb-header" (click)="sidebarExpand.jury_duty = !sidebarExpand.jury_duty">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.jury_duty ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Jury Duty
    </h5>
  </div>
  <div class="matter-sb-content px-3" *ngIf="sidebarExpand.jury_duty">
    <div class="float-right">
      <button type="button" title="Refresh" [disabled]="loadingSidebarInfo" (click)="loadContact(false)" class="btn btn-outline-primary btn-sm">
        <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingSidebarInfo }"></i>
      </button>
    </div>
    <div class="clearfix"></div>
    <div class="p-3">
      <div class="matter-sb-header" (click)="sidebarExpand.jury_duty_history = !sidebarExpand.jury_duty_history">
        <h6 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.jury_duty_history ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Jury Duty History
        </h6>
      </div>
      <div class="matter-sb-content" *ngIf="sidebarExpand.jury_duty_history">
        <div class="row">
          <div class="col-7">Start Date:</div>
          <div class="col-5 text-center">{{ sidebarContactInfo.start_date }}</div>
        </div>
        <div class="row" *ngFor="let event of sidebarContactInfo.jury_duty_history">
          <div class="col-7">
            <a [href]="'/events/' + event.id">{{ event.date }}</a>
          </div>
          <div class="col-5 text-center">{{ event.days_consumed }}</div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-7 font-weight-bold">Anniversary Date</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.anniversary_date }}</div>
    </div>
    <div class="row" *ngFor="let event of sidebarContactInfo.jury_duty_days_out">
      <div class="col-7 font-weight-bold">
        <a [href]="'/events/' + event.id">{{ event.date }}</a>
      </div>
      <div class="col-5 text-center">{{ event.days_consumed }}</div>
    </div>
    <div class="row mt-3">
      <div class="col-7">Days Out:</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.jury_duty_days_out_total }}</div>
    </div>
    <div class="row">
      <div class="col-7">Days Entitled:</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.jury_duty_days_off }}</div>
    </div>
    <div class="row" [ngClass]="{ 'font-weight-bold': sidebarContactInfo.jury_duty_overpaid, 'text-danger': sidebarContactInfo.jury_duty_overpaid }">
      <div class="col-7">{{ sidebarContactInfo.jury_duty_text }}</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.jury_duty_days }}</div>
    </div>
    <br /><br />
  </div>
</div>
<div *ngIf="sidebarContactInfo && sidebarContactInfo.anniversary_date">
  <div class="matter-sb-header" (click)="sidebarExpand.sick_leave = !sidebarExpand.sick_leave">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.sick_leave ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Sick Leave
    </h5>
  </div>
  <div class="matter-sb-content px-3" *ngIf="sidebarExpand.sick_leave">
    <div class="float-right">
      <button type="button" title="Refresh" [disabled]="loadingSidebarInfo" (click)="loadContact(false)" class="btn btn-outline-primary btn-sm">
        <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingSidebarInfo }"></i>
      </button>
    </div>
    <div class="clearfix"></div>
    <div class="p-3">
      <div class="matter-sb-header" (click)="sidebarExpand.sick_leave_history = !sidebarExpand.sick_leave_history">
        <h6 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.sick_leave_history ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Sick Days History
        </h6>
      </div>
      <div class="matter-sb-content" *ngIf="sidebarExpand.sick_leave_history">
        <div class="row">
          <div class="col-7">Start Date:</div>
          <div class="col-5 text-center">{{ sidebarContactInfo.start_date }}</div>
        </div>
        <div class="row" *ngFor="let event of sidebarContactInfo.sick_history">
          <div class="col-7">
            <a [href]="'/events/' + event.id">{{ event.date }}</a>
          </div>
          <div class="col-5 text-center">{{ event.days_consumed }}</div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-7 font-weight-bold">Anniversary Date</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.anniversary_date }}</div>
    </div>
    <div class="row" *ngFor="let event of sidebarContactInfo.sick_days_out">
      <div class="col-7 font-weight-bold">
        <a [href]="'/events/' + event.id">{{ event.date }}</a>
      </div>
      <div class="col-5 text-center">{{ event.days_consumed }}</div>
    </div>
    <div class="row mt-3">
      <div class="col-7">Days Out:</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.sick_days_out_total }}</div>
    </div>
    <div class="row">
      <div class="col-7">Days Entitled:</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.sick_days_off }}</div>
    </div>
    <div class="row" [ngClass]="{ 'font-weight-bold': sidebarContactInfo.sick_overpaid, 'text-danger': sidebarContactInfo.sick_overpaid }">
      <div class="col-7">{{ sidebarContactInfo.sick_text }}</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.sick_days }}</div>
    </div>
    <br /><br />
  </div>
</div>
<div *ngIf="sidebarContactInfo && sidebarContactInfo.anniversary_date">
  <div class="matter-sb-header" (click)="sidebarExpand.vacation = !sidebarExpand.vacation">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.vacation ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Vacation
    </h5>
  </div>
  <div class="matter-sb-content px-3" *ngIf="sidebarExpand.vacation">
    <div class="float-right">
      <button type="button" title="Refresh" [disabled]="loadingSidebarInfo" (click)="loadContact(false)" class="btn btn-outline-primary btn-sm">
        <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingSidebarInfo }"></i>
      </button>
    </div>
    <div class="clearfix"></div>
    <div class="p-3">
      <div class="matter-sb-header" (click)="sidebarExpand.vacation_history = !sidebarExpand.vacation_history">
        <h6 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.vacation_history ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Vacation History
        </h6>
      </div>
      <div class="matter-sb-content" *ngIf="sidebarExpand.vacation_history">
        <div class="row">
          <div class="col-7">Start Date:</div>
          <div class="col-5 text-center">{{ sidebarContactInfo.start_date }}</div>
        </div>
        <div class="row" *ngFor="let event of sidebarContactInfo.vacation_history">
          <div class="col-7">
            <a [href]="'/events/' + event.id">{{ event.date }}</a>
          </div>
          <div class="col-5 text-center">{{ event.days_consumed }}</div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-7 font-weight-bold">Anniversary Date</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.anniversary_date }}</div>
    </div>
    <div class="row" *ngFor="let event of sidebarContactInfo.vacation_days_out">
      <div class="col-7">
        <a [href]="'/events/' + event.id">{{ event.date }}</a>
      </div>
      <div class="col-5 text-center">{{ event.days_consumed }}</div>
    </div>
    <div class="row mt-3">
      <div class="col-7">Days Out:</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.vacation_days_out_total }}</div>
    </div>
    <div class="row">
      <div class="col-7">Days Entitled:</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.vacation_days_off }}</div>
    </div>
    <div class="row" [ngClass]="{ 'font-weight-bold': sidebarContactInfo.vacation_overpaid, 'text-danger': sidebarContactInfo.vacation_overpaid }">
      <div class="col-7">{{ sidebarContactInfo.vacation_text }}</div>
      <div class="col-5 text-center">{{ sidebarContactInfo.vacation_days }}</div>
    </div>
    <br /><br />
  </div>
</div>
<div>
  <div class="matter-sb-header" (click)="sidebarExpand.vendor_records = !sidebarExpand.vendor_records">
    <h5 class="font-weight-normal">
      <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (sidebarExpand.vendor_records ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Vendor Records
    </h5>
  </div>
  <div class="matter-sb-content" *ngIf="sidebarExpand.vendor_records">
    <app-contact-vendors [contactId]="contact_id"></app-contact-vendors>
    <br /><br />
  </div>
</div>
<br />
